const createTable = require('../createTable')

/**
 * Insert a new table
 *
 * @param {Object} opts
 * @param {Slate.Transform} transform
 * @param {Number} columns
 * @param {Number} rows
 * @return {Slate.Transform}
 */
function insertTable (opts, transform, columns = 2, rows = 2) {
  const { state } = transform

  if (opts.isAccordion) {
    columns = 1
  }

  if (!state.selection.startKey) return false

    // Create the table node
  const fillWithEmptyText = (x, y) => ''
  const table = createTable(opts, columns, rows, fillWithEmptyText)

  const done = transform
        .insertBlock(table)
  done
    .collapseToEndOf(table.nodes.get(0).nodes.get(0))
    .focus()
  return done
}

module.exports = insertTable



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/deep-table-plugin/transforms/insertTable.js